import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var URL_PREFIX = "/academy/";
var URL_PATTERN = "^".concat(URL_PREFIX);
export var getCourseSlugFromUrl = function getCourseSlugFromUrl(url) {
  return url.replace(new RegExp(URL_PATTERN), "").replace("/", "");
};
export var getLessonSlugFromUrl = function getLessonSlugFromUrl(url) {
  return url.replace(new RegExp("".concat(URL_PATTERN, "[a-z1-9-]+/")), "").replace("/", "");
};

var getImageDataFromAsset = function getImageDataFromAsset(asset) {
  var _asset$fields$file$de, _asset$fields$file$de2;

  return {
    src: asset.fields.file.url,
    title: asset.fields.title,
    width: (_asset$fields$file$de = asset.fields.file.details.image) === null || _asset$fields$file$de === void 0 ? void 0 : _asset$fields$file$de.width,
    height: (_asset$fields$file$de2 = asset.fields.file.details.image) === null || _asset$fields$file$de2 === void 0 ? void 0 : _asset$fields$file$de2.height
  };
};

var transformLessonResponse = function transformLessonResponse(_ref) {
  var _res$faqs;

  var res = _ref.res,
      courseNumber = _ref.courseNumber,
      lessonIndex = _ref.lessonIndex,
      numberOfLessons = _ref.numberOfLessons;
  return {
    title: res.title,
    url: res.url,
    slug: getLessonSlugFromUrl(res.url),
    description: res.lessonDescription,
    image: res.socialImage && getImageDataFromAsset(res.socialImage),
    timeToRead: res.timeToRead,
    authors: res.authors,
    courseTitle: res.courseTitle,
    content: res.content,
    faqs: (_res$faqs = res.faqs) === null || _res$faqs === void 0 ? void 0 : _res$faqs.map(function (faq) {
      return faq.fields;
    }),
    courseNumber: courseNumber,
    lessonNumber: lessonIndex + 1,
    isLastLessonInCourse: lessonIndex + 1 === numberOfLessons
  };
};

var transformCourseResponse = function transformCourseResponse(res) {
  var courseNumber = res.academyCourseNumber;
  var courseIcon = getImageDataFromAsset(res.courseIcon);
  var lessons = res.lessons.map(function (lesson, index) {
    return _objectSpread(_objectSpread({}, transformLessonResponse({
      res: lesson.fields,
      courseNumber: courseNumber,
      lessonIndex: index,
      numberOfLessons: res.lessons.length
    })), {}, {
      courseIcon: courseIcon
    });
  });
  return {
    title: res.title,
    url: res.url,
    description: res.description,
    slug: getCourseSlugFromUrl(res.url),
    courseNumber: courseNumber,
    courseIcon: courseIcon,
    lessons: lessons
  };
};

export var fetchAllCourses = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client, options) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return client.get("/content/entries/analyticsAcademyCourse?order=fields.academyCourseNumber", options);

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.map(transformCourseResponse));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchAllCourses(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var fetchAllSlugs = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client, options) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("/content/entries/analyticsAcademyLesson", options);

          case 2:
            res = _context2.sent;
            return _context2.abrupt("return", res.filter(function (lesson) {
              return !lesson.url.includes("/archives/");
            }).map(function (_ref4) {
              var url = _ref4.url;
              return {
                courseSlug: url.split("/")[2],
                lessonSlug: url.split("/")[3]
              };
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchAllSlugs(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();